import {
  Box,
  Button,
  Grid,
  Group,
  LoadingOverlay,
  TextInput,
  Textarea,
} from "@mantine/core";
import { useForm, hasLength } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconCheck, IconWindow, IconX } from "@tabler/icons-react";
import { modals } from "@mantine/modals";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import Repository from "../../../_base/helper/HttpHelper";
import { API_ROUTE } from "../../../const/apiRoute";
import ButtonClose from "../../../common/ButtonClose/ButtonClose";

interface CreateViewProps {
  onClose: (refresh: boolean) => void;
}

const CreateProductCategoryView = ({ onClose }: CreateViewProps) => {
  const [loading, { open, close }] = useDisclosure(false);
  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);

  const form = useForm({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      id: 0,
      title: "",
      description: "",
      googleCategoryId: "",
      productCount: 0,
      searchFulltext: "",
      createTime: new Date().toISOString(),
      createBy: "",
      lastUpdate: new Date().toISOString(),
      lastUpdateBy: "",
    },
    validate: {
      title: hasLength({ min: 3 }, "Tên danh mục phải dài hơn 3 ký tự"),
      // googleCategoryId: hasLength({ min: 1 }, "Bắt buộc nhập Google Category ID"),
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    open();
    const res = await repository.post<MessageResponse<boolean>>(
      API_ROUTE.CREATE_FACEBOOK_ADS,
      values
    );
    if (res?.success) {
      NotificationExtension.Success("Thêm mới thành công!");
      onClose(true);
      modals.closeAll();
    } else {
      NotificationExtension.Fails("Thêm mới thất bại!");
    }
    close();
  };

  return (
    <Box
      component="form"
      onSubmit={form.onSubmit(handleSubmit)}
      style={{ position: "relative", width: 500 }}
    >
      <LoadingOverlay visible={loading} />
      <Grid>
        <Grid.Col span={12}>
          <TextInput
            label="Tên danh mục"
            withAsterisk
            {...form.getInputProps("title")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label="Google Category ID"
            {...form.getInputProps("googleCategoryId")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Textarea label="Mô tả" {...form.getInputProps("description")} />
        </Grid.Col>
      </Grid>
      <Group
        justify="center"
        mt="xs"
        p="5px 0"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="submit"
          color="blue"
          leftSection={<IconCheck size={16} />}
          loading={loading}
        >
          Lưu
        </Button>
        <ButtonClose />
      </Group>
    </Box>
  );
};

export default CreateProductCategoryView;
